"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Breadcrumb", {
    enumerable: true,
    get: function() {
        return Breadcrumb;
    }
});
var _anatomy = require("@chakra-ui/anatomy");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var Breadcrumb = {
    parts: _anatomy.breadcrumbAnatomy.keys,
    baseStyle: function(param) {
        var theme = param.theme;
        return {
            container: {
                "> ol": {
                    display: "flex",
                    flexWrap: "wrap"
                }
            },
            item: _object_spread_props(_object_spread({}, theme.textStyles["text-body-medium"]), {
                color: "text-secondary"
            }),
            separator: _object_spread_props(_object_spread({}, theme.textStyles["text-body-medium"]), {
                color: "text-secondary",
                mx: "0.5rem",
                lineHeight: "1rem"
            }),
            link: _object_spread_props(_object_spread({}, theme.components.Link.sizes.m), {
                _hover: {
                    textDecoration: "none"
                },
                _focus: {
                    boxShadow: "0 0 0 0.1875rem var(--chakra-colors-primary-focus)"
                }
            })
        };
    }
};
